import React, {useState} from "react";
import _ from 'lodash';
import {extract, formatValue, renderValue, wrapArray, getFormData, flatArray, asIcon, visibleDim} from "../../utils";
import {withFormikFormControl} from "../../FormikFormControl";
import {useFormikContext} from "formik";
import {Navigator} from "../../DisplayRendering/Navigator";
import {useStore} from "../../../@redux";
import {Dialog} from "primereact/dialog";
import {Toolbar} from "primereact/toolbar";
import {Divider} from "primereact/divider";
const Embed = (props) => {
    const store = useStore()
    const {extraConfig = {}, ...rest} = props
    const [isFs, setFs] = useState(false)
    const [vw,vh] = visibleDim()
    const {width ='', height = '', title, views:views_raw = ['external', 'fullscreen'], style={}, source_field, source_sub_field, emptyMessage, embed_source:source = 'field', embed_format = 'url', embed_static = ''} = extraConfig
    const {
        values,
        setFieldValue,
        setFieldError, errors
    } = useFormikContext();
    const embed_source = source ?? 'field'
    let url = embed_source === 'field' ? ( source_field ? values[source_field] : null ) : embed_static
    const view_modes = wrapArray(views_raw)
    const can_open = view_modes.includes('external')
    const can_fs = view_modes.includes('fullscreen')
    if(embed_source === 'field' && source_sub_field?.id && Array.isArray(url)){
        let items = []
        for(let i of url){
            let subValue = i[source_sub_field?.id] ?? i[source_sub_field?.name]
            if(Array.isArray(subValue)){
                items = items.concat(subValue)
            }else if(!_.isEmpty(subValue)){
                items.push(subValue)
            }
        }
        url = items
    }
    url = flatArray(url,embed_format !== 'code')
    const renderConfig = {render_as: embed_format === 'code' ? 'html' : 'frame', width, height: `${isFs ? vh - 185 : (height || 500)}`, style, html: {sandbox:true, frame:true}}

    console.log("**EMBED FIELD**", {url, embed_source, embed_format, embed_static, source_field, values, source_sub_field, renderConfig, extraConfig})
    if(url.length === 0){
        return <p>{emptyMessage || 'No URL Available'}</p>
    }else {
        let inner = <></>
        const toolbar = (val) => {

            return (
                <>
                    {can_fs && (
                        <>
                            {asIcon(isFs ? 'window-minimize' : 'window-maximize', 'Full Screen', isFs, () => setFs(!isFs))}
                        </> )}

                    {can_open && (
                        <>
                            { (can_fs) && <Divider layout="vertical" style={{ height: '10px' }} />}
                            {asIcon('external-link', 'Open in New Tab', false, _.isObject(val as any) ? val.url || val.value : val)}
                        </> )}

                </>
            )
        }
        const withToolbar = (item) => {
            return (
                <>
                    <Toolbar style={{ height: '0px', position: 'relative', background: 'none', border: 'none', top: '-50px', padding: 0, paddingRight: '15px' }}  end={toolbar(item)} />
                    {renderValue(item, renderConfig)}
                </>
            )
        }
        if (url.length === 1) {
            inner = withToolbar(url[0])
        } else {
            inner = <Navigator value={url} render={item => withToolbar(item)} extraConfig={extraConfig}/>
        }
        if(isFs){
            return <Dialog header={title} onHide={() => setFs(false)} draggable={false} maximized={true} visible={true} closable={true}>{inner}</Dialog>
        }else{
            return inner
        }
    }

};

export default withFormikFormControl({  })(Embed);

